import React, { FC } from "react";
import { UserRole } from "@green0meter/api-client";

import {
  DefaultFeatureRecommendationsCard,
  PersonalizedRecommendationsCard,
} from "./components";

import { Grid } from "@components/base";
import { useUserStore } from "@store/user";

interface Recommendations {}

const Recommendations: FC<Recommendations> = () => {
  const { user } = useUserStore();
  const isOwnerOrManager =
    user?.role === UserRole.Owner || user?.role === UserRole.Manager;

  return (
    <Grid size={12}>
      {isOwnerOrManager ? (
        <PersonalizedRecommendationsCard />
      ) : (
        <DefaultFeatureRecommendationsCard />
      )}
    </Grid>
  );
};

export default Recommendations;
